import { render, staticRenderFns } from "./SliderAds.vue?vue&type=template&id=221b903a&scoped=true"
import script from "./SliderAds.vue?vue&type=script&lang=js"
export * from "./SliderAds.vue?vue&type=script&lang=js"
import style0 from "./SliderAds.vue?vue&type=style&index=0&id=221b903a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b903a",
  null
  
)

export default component.exports